import React, { useState, useRef, useEffect, useContext } from 'react'
import { useHistory, useParams, Link } from 'react-router-dom'
import UserContext from '../../config/UserContext'
import {
  HttpService,
  API,
  SimpleReactValidator,
  Title,
  toast,
  Messages,
  Nestable,
  // FileUploadWithPreview,
  getBase64,
  Spinner,
  Common
} from '../../config/react'

const AddProductAttribute = () => {
  let ImageArry = []
  const defaultImage = Common.setImage('assets/images/default.png')
  const urlParams = useParams()
  const bottomRef = useRef()
  const history = useHistory()
  const validator = useRef(new SimpleReactValidator())
  const user = useContext(UserContext)
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [OptionItems, setOptionItems] = useState([])
  const [IsAuth, setIsAuth] = useState(false)
  const [loading, setLoading] = useState(true)
  const [OptionImages, setOptionImages] = useState([])
  const [IsInvalidFileFormat, setIsInvalidFileFormat] = useState(0)

  const optionImageFilesRefArray = useRef([])
  const optionImagesRefArray = useRef([])

  const [Inputs, setInputs] = useState({
    id: 0,
    attribute_name: '',
    attribute_code: '',
    description: '',
    input_type: '',
    show_in_storefront: 0,
    show_in_detail_page: 0,
    // default_value: '',
    status: 0,
    options: [],
    optionid: []
  })
  const [duplicateError, setDuplicateError] = useState({})

  useEffect(() => {
    setIsAuth(true)
    setLoading(false)
    document.title = Title.AddProductAttribute
    if (urlParams.id !== undefined) {
      document.title = Title.EditProductAttribute
      GetProductAttributeDetail()
    }
  }, [urlParams.id])

  const handleInputChanges = (prop) => (event) => {
    if (prop === 'status' || prop === 'show_in_storefront' || prop === 'show_in_detail_page') {
      setInputs({ ...Inputs, [prop]: event.target.checked })
    } else {
      setInputs({ ...Inputs, [prop]: event.target.value })
    }
    setForceUpdate(!isForceUpdate)
  }

  const handleText = (i) => (e) => {
    const pointer = e.target.selectionStart
    const element = e.target
    window.requestAnimationFrame(() => {
      element.selectionStart = pointer
      element.selectionEnd = pointer
    })

    const options = [...Inputs.options]
    const index = options.findIndex((x) => x.id === i)
    const newValue = e.target.value.trim()

    // Check for duplicate values (case-insensitive)
    const isDuplicate = options.some(
      (option) =>
        option.id !== i &&
        option.value &&
        option.value.trim().toLowerCase() === newValue.toLowerCase()
    )

    if (isDuplicate && newValue !== '') {
      setDuplicateError({ [i]: 'This option already exists' })
    } else {
      setDuplicateError({ [i]: '' })
    }

    options[index] = {
      id: options[index].id !== undefined ? options[index].id : '',
      value: e.target.value,
      value_image: options[index].value_image !== undefined ? options[index].value_image : '',
      sort_order: options[index].sort_order !== undefined ? options[index].sort_order : index
    }
    setInputs({ ...Inputs, options })
    setForceUpdate(!isForceUpdate)
  }

  const handleDelete = (i) => (e) => {
    e.preventDefault()
    let options = [...Inputs.options]

    options = options.filter((x) => x.id !== i)
    const optionImages = OptionImages.filter((item) => parseInt(item.imageId) !== i)
    setOptionImages(optionImages)
    const optionIds = []
    options.map(function (optionItem, key) {
      optionIds.push(optionItem.id)
      // const optionImage = OptionImages.filter((item) => parseInt(item.imageId) === optionItem.id)[0]
      // options[key].value_image =
      //   Inputs.attribute_name.replace(/ /g, '_') +
      //   '_' +
      //   optionItem.value.replaceAll(' ', '_') +
      //   optionImage.type
      // setTimeout(() => {
      //   initImagePlugin(optionItem.id, optionImage.image)
      // }, 500)
      return true
    })
    Inputs.optionid = optionIds
    Inputs.options = options
    setForceUpdate(!isForceUpdate)
  }

  const addOption = (e) => {
    e.preventDefault()
    const options = Inputs.options
    const optionId = Math.floor(1000 + Math.random() * 9000)
    if (options.filter((item) => item.id === optionId).length < 1)
      if (OptionItems.length > 0)
        options.push({
          id: optionId,
          value: '',
          value_image: '',
          sort_order: Math.max(...OptionItems.map((o) => o.sort_order)) + 1
        })
      else options.push({ id: optionId, value: '', sort_order: 0 })
    options.forEach((item, index) => {
      item.sort_order = index
    })
    const optionid = optionId
    const optionIds = Inputs.optionid
    optionIds.push(optionid)
    Inputs.optionid = optionIds
    Inputs.options = options
    // setTimeout(() => {
    //   initImagePlugin(optionid)
    // }, 500)
    setForceUpdate(!isForceUpdate)
  }

  const GetProductAttributeDetail = () => {
    const param = {
      id: urlParams.id
    }
    setLoading(true)
    HttpService.postApi(API.GetProductAttributeDetail, param).then((response) => {
      setLoading(false)
      if (response.data.result !== null) {
        const data = response.data.result[0]

        data.map((item) =>
          Object.keys(item).map(function (key, value) {
            if (key === 'attribute_options' && item.attribute_options !== null) {
              const options = item.attribute_options
              const IsOptionValues = options.filter((x) => x.value !== null).length > 0
              if (IsOptionValues) {
                options.sort(function (a, b) {
                  return a.sort_order - b.sort_order
                })

                options.map(async function (optionItem, key) {
                  Inputs.optionid.push(optionItem.id)
                  // setTimeout(() => {
                  //   initImagePlugin(optionItem.id, optionItem.value_image)
                  // }, 500)
                  return true
                })
                Inputs.options = options
                setOptionItems(options)
              }
            } else {
              Inputs[key] = item[key]
            }
            return true
          })
        )
        setForceUpdate(!isForceUpdate)
      }
      if (response.data.message) {
        toast.warning(response.data.message)
        history.push('/attribute/productattribute')
        setForceUpdate(!isForceUpdate)
      }
    })
  }
  // const initImagePlugin = (imageId = null, image = null) => {
  //   if (image !== '' && image !== null) {
  //     new FileUploadWithPreview('attrImages_' + imageId, {
  //       text: {
  //         chooseFile: 'Choose Image...'
  //       },
  //       presetFiles: [image]
  //     })
  //   } else {
  //     new FileUploadWithPreview('attrImages_' + imageId, {
  //       text: {
  //         chooseFile: 'Choose Image...'
  //       }
  //     })
  //   }
  // }
  window.addEventListener('fileUploadWithPreview:imagesAdded', async function (e) {
    e.preventDefault()
    const imageType = e.detail.cachedFileArray[0].type
    let type = ''
    if (e.detail.cachedFileArray[0].type.includes('svg')) type = 'svg'
    else type = e.detail.cachedFileArray[0].type.split('/')[1]

    const size = e.detail.cachedFileArray[0].size
    const Id = e.detail.uploadId.split('_')[1]
    if (
      imageType === 'image/jpeg' ||
      imageType === 'image/jpg' ||
      imageType === 'image/png' ||
      imageType === 'image/webp' ||
      imageType === 'image/svg+xml'
    ) {
      if (size <= 2097152) {
        const image = await new Promise((resolve, reject) => {
          getBase64(e.detail.cachedFileArray[0], (result) => {
            resolve({ imageId: Id, image: result, type: '.' + type })
          })
        })
        ImageArry = OptionImages
        if (ImageArry.filter((item) => item.imageId === image.imageId).length < 1)
          ImageArry.push(image)
        setOptionImages(ImageArry)
      }
    }
    setForceUpdate(!isForceUpdate)
  })

  window.addEventListener('fileUploadWithPreview:clearButtonClicked', function (e) {
    if (OptionImages.length > 0) {
      const Id = e.detail.uploadId.split('_')[1]
      const images = OptionImages.filter((x) => x.imageId !== Id)
      setOptionImages(images)
    }
  })

  const SubmitForm = (e) => {
    if (!validator.current.allValid()) {
      validator.current.showMessages()
      setForceUpdate(!isForceUpdate)
      return
    }

    // Check for duplicate options before submission
    const optionValues = Inputs.options.map((opt) => opt.value.trim().toLowerCase())
    const hasDuplicates = optionValues.some((value, index) => optionValues.indexOf(value) !== index)

    if (hasDuplicates) {
      toast.warning('Please remove duplicate options before submitting')
      return
    }

    const options = []
    const selectedOptionIds = Inputs.optionid
    for (let i = 0; i < selectedOptionIds.length; i++) {
      if (selectedOptionIds[i] > 0) {
        options.push(selectedOptionIds[i])
      }
    }
    const param = {
      id: Inputs.id,
      attribute_name: Inputs.attribute_name,
      attribute_code: Inputs.attribute_code,
      description: Inputs.description,
      input_type: Inputs.input_type,
      show_in_storefront: Inputs.show_in_storefront,
      show_in_detail_page: Inputs.show_in_detail_page,
      // default_value: Inputs.default_value,
      status: Inputs.status,
      attribute_options: Inputs.options,
      selected_options_id: options.join(','),
      Userid: user.id
    }

    // return

    if (urlParams.id === undefined) {
      setLoading(true)
      HttpService.postApi(API.AddProductAttribute, param).then((response) => {
        setLoading(false)

        if (response.data.message) {
          toast.warning(response.data.message)
          setForceUpdate(!isForceUpdate)
          return
        }
        toast.success(Messages.RecordAdded)
        setForceUpdate(!isForceUpdate)
        history.push('/attribute/productattribute')
      })
    } else {
      setLoading(true)
      HttpService.postApi(API.UpdateProductAttribute, param).then((response) => {
        setLoading(false)

        if (response.data.message) {
          toast.warning(response.data.message)
          setForceUpdate(!isForceUpdate)
          return
        }
        toast.success(Messages.RecordUpdated)
        setForceUpdate(!isForceUpdate)
        history.push('/attribute/productattribute')
      })
    }
  }
  const styles = {
    position: 'relative',
    padding: '10px 15px',
    fontSize: '15px',
    border: '1px solid #f9fafa',
    background: '#f9fafa',
    cursor: 'move'
  }
  const handleOptionImageChange = async (e, optionId) => {
    optionImagesRefArray.current[optionId].src = URL.createObjectURL(e.target.files[0])
    const optionIndex = Inputs.options.findIndex((item) => item.id === optionId)
    const options = Inputs.options
    const image = await new Promise((resolve, reject) => {
      getBase64(e.target.files[0], (result) => {
        resolve(result)
      })
    })
    if (image.split('/')[0] !== 'data:image') {
      setIsInvalidFileFormat(IsInvalidFileFormat + 1)
    }
    options[optionIndex].value_image = image
    options[optionIndex].preview_image = URL.createObjectURL(e.target.files[0])
    setInputs({ ...Inputs, options: options })
  }

  const deleteOptionImage = async (e, optionId) => {
    clearFileInput(optionId)
    optionImagesRefArray.current[optionId].src = defaultImage
    const optionIndex = Inputs.options.findIndex((item) => item.id === optionId)
    const options = Inputs.options
    options[optionIndex].value_image = ''
    options[optionIndex].preview_image = defaultImage
    setInputs({ ...Inputs, options: options })
    Inputs.options.map((item) => {
      if (item.value_image !== '' && item.value_image.includes('http') !== true) {
        if (item.value_image.split('/')[0] !== 'data:image') {
          setIsInvalidFileFormat(IsInvalidFileFormat + 1)
        }
      } else {
        setIsInvalidFileFormat(IsInvalidFileFormat - 1)
      }
      return true
    })
  }
  const clearFileInput = (id) => {
    if (optionImageFilesRefArray.current[id]) {
      optionImageFilesRefArray.current[id].value = ''
    }
  }

  const renderItem = (item) => {
    return (
      <div
        className="attribute-option-container"
        style={styles}
      >
        <div className="row form-group mb-0">
          <div
            className={
              Inputs.input_type === 'radio'
                ? 'col-md-4 pr-3 pr-md-1 mb-2 mb-md-0'
                : 'col-md-10 pr-3 pr-md-1 mb-2 mb-md-0'
            }
          >
            <input
              type="text"
              className="form-control"
              name="options[]"
              data-id={item.item.id}
              placeholder="Option"
              onChange={handleText(item.item.id)}
              value={item.item.value}
            />
            {validator.current.message('Option', item.item.value, 'required', {
              className: 'error'
            })}
            {duplicateError[item.item.id] && (
              <div className="error">{duplicateError[item.item.id]}</div>
            )}
          </div>
          {Inputs.input_type === 'radio' && (
            <div className="col-md-6 pr-3 pr-md-1 mb-2 mb-md-0">
              <div className="d-flex">
                <input
                  type="file"
                  name="option_images[]"
                  className="form-control mr-2 option-image-file"
                  onChange={(e) => handleOptionImageChange(e, item.item.id)}
                  ref={(ref) => {
                    optionImageFilesRefArray.current[item.item.id] = ref
                  }}
                  id={'option_image_' + item.item.id}
                  style={{ display: 'block' }}
                />

                <div className="image-container">
                  <img
                    className="option-image"
                    src={
                      item.item.value_image !== null &&
                      item.item.value_image !== '' &&
                      item.item.value_image !== undefined
                        ? item.item.value_image
                        : defaultImage
                    }
                    ref={(ref) => {
                      optionImagesRefArray.current[item.item.id] = ref
                    }}
                  />
                  {item.item.value_image !== null &&
                    item.item.value_image !== '' &&
                    item.item.value_image !== undefined &&
                    item.item.value_image.toLowerCase().indexOf('default') < 0 && (
                      <div
                        className="delete-icon"
                        onClick={(e) => deleteOptionImage(e, item.item.id)}
                      >
                        <span>&times;</span>
                      </div>
                    )}
                </div>
              </div>
              <div
                style={
                  item.item.value_image !== undefined &&
                  item.item.value_image !== null &&
                  item.item.value_image !== '' &&
                  item.item.value_image.includes('https')
                    ? { display: 'none' }
                    : item.item.value_image !== undefined &&
                        item.item.value_image !== null &&
                        item.item.value_image !== '' &&
                        item.item.value_image.split(';')[0] !== 'data:image/png' &&
                        item.item.value_image.split(';')[0] !== 'data:image/jpeg' &&
                        item.item.value_image.split(';')[0] !== 'data:image/jpg' &&
                        item.item.value_image.split(';')[0] !== 'data:image/svg+xml' &&
                        item.item.value_image.split(';')[0] !== 'data:image/webp'
                      ? {}
                      : { display: 'none' }
                }
                className="error"
              >
                {Messages.formatnotsupport}
              </div>
            </div>
          )}

          <div className="col-auto pl-2 pl-md-1 ml-2 ml-md-0">
            <button
              className="btn btn-danger input-btn btn-block"
              onClick={handleDelete(item.item.id)}
              disabled={item.item.is_product_exist}
              title={item.item.is_product_exist ? Messages.ProductAttributeOptionDeleteError : ''}
            >
              X
            </button>
          </div>
          <div className="col-md-4 pr-1"></div>
        </div>
      </div>
    )
  }

  const changeOptionOrder = (item) => {
    const attributeOptions = []

    item.items.map((item, index) => {
      attributeOptions.push({
        id: item.id, // Math.floor(1000 + Math.random() * 9000),
        //  optionid: ,
        value: item.value,
        value_image: item.value_image,
        sort_order: index
      })
      return true
    })

    setInputs({ ...Inputs, options: attributeOptions })
    // if (urlParams.id !== undefined) {
    //   const param = {
    //     items: attributeOptions
    //   }

    //   HttpService.postApi(API.ChangeAttributeOptionOrder, param).then((response) => {
    //     GetProductAttributeDetail()
    //   })
    // }
  }
  // const onAttributeNameChange = (e) => {
  //   const attributeCode = e.target.value.toLowerCase().replace(/ /g, '_')
  //   setInputs({ ...Inputs, attribute_code: attributeCode })
  //   setForceUpdate(!isForceUpdate)
  // }
  return !IsAuth || loading ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title mb-0">
          {' '}
          {urlParams.id === null || urlParams.id === undefined
            ? Title.AddProductAttribute
            : Title.EditProductAttribute}{' '}
        </h3>
        <div className="btn-group">
          <button
            type="button"
            className="btn btn-dark btn-fw rounded mr-2"
            onClick={history.goBack}
          >
            {' '}
            Back{' '}
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <form className="forms-sample">
                <div className="row">
                  <div className="col-md-4 col-lg-6">
                    <div className="form-group">
                      <label>Attribute Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="attribute_name"
                        onChange={handleInputChanges('attribute_name')}
                        // onBlur={(e) => onAttributeNameChange(e)}
                        defaultValue={Inputs.attribute_name}
                        placeholder="Attribute Name"
                      />
                      {validator.current.message(
                        'Attribute Name',
                        Inputs.attribute_name,
                        'required|alpha_num_space',
                        { className: 'error' }
                      )}
                    </div>
                    <div className="form-group">
                      <label>Attribute Code</label>
                      <input
                        type="text"
                        className="form-control"
                        name="attribute_code"
                        onChange={handleInputChanges('attribute_code')}
                        defaultValue={Inputs.attribute_code}
                        placeholder="Attribute Code"
                        readOnly={urlParams.id !== undefined}
                      />
                      {validator.current.message(
                        'Attribute Code',
                        Inputs.attribute_code,
                        'required|alpha_num_dash',
                        { className: 'error' }
                      )}
                    </div>
                    <div className="form-group">
                      <label>Description</label>
                      <input
                        type="text"
                        className="form-control"
                        name="description"
                        onChange={handleInputChanges('description')}
                        defaultValue={Inputs.description}
                        placeholder="Description"
                      />
                      {/* {validator.current.message('Description', Inputs.description, 'required', {
                        className: 'error'
                      })} */}
                    </div>
                    <div className="form-group">
                      <label>Input Type</label>
                      <select
                        className="form-control"
                        name="input_type"
                        value={Inputs.input_type}
                        onChange={handleInputChanges('input_type')}
                      >
                        <option value="">--Select--</option>
                        <option value="dropdown">Dropdown</option>
                        <option value="text">Textbox</option>
                        <option value="radio">Radio Button</option>
                        {/* <option value="text_swatch">Text Swatch</option> */}
                        <option value="checkbox">Checkbox</option>
                        <option value="slider">Slider</option>
                        <option value="range_slider">Range Slider</option>
                      </select>
                      {validator.current.message('Input Type', Inputs.input_type, 'required', {
                        className: 'error'
                      })}
                    </div>
                    {/* <div className="form-group">
                      <label>Default Value</label>
                      <input
                        type="text"
                        className="form-control"
                        name="default_value"
                        onChange={handleInputChanges('default_value')}
                        defaultValue={Inputs.default_value}
                        placeholder="Default Value"
                      />
                      {validator.current.message(
                        'Default Value',
                        Inputs.default_value,
                        'required',
                        { className: 'error' }
                      )}
                    </div> */}
                    <div className="row">
                      <div className="col-6 col-md-6 col-lg-4 mb-3 mb-lg-0">
                        <label
                          htmlFor="exampleInputUsername2"
                          className="col-sm-12"
                        >
                          Visible In Filters
                        </label>
                        <div className="col-sm-12">
                          <div className="custom-control custom-switch mt-1">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name="show_in_storefront"
                              onChange={handleInputChanges('show_in_storefront')}
                              id="show_in_storefront"
                              checked={Inputs.show_in_storefront}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="show_in_storefront"
                            >
                              {' '}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-6 col-md-6 col-lg-5 mb-3 mb-lg-0">
                        <label
                          htmlFor="exampleInputUsername2"
                          className="col-sm-12"
                        >
                          Visible In Product Page
                        </label>
                        <div className="col-sm-12">
                          <div className="custom-control custom-switch mt-1">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name="show_in_detail_page"
                              onChange={handleInputChanges('show_in_detail_page')}
                              id="show_in_detail_page"
                              checked={Inputs.show_in_detail_page}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="show_in_detail_page"
                            >
                              {' '}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
                        <label
                          htmlFor="exampleInputUsername3"
                          className="col-sm-12"
                        >
                          Status
                        </label>
                        <div className="col-sm-12">
                          <div className="custom-control custom-switch mt-1 pointer">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name="status"
                              onChange={handleInputChanges('status')}
                              id="status"
                              checked={Inputs.status}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="status"
                            >
                              {' '}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-5">
                      <div className="col-md-12">
                        <button
                          type="button"
                          onClick={SubmitForm}
                          className="btn btn-custom text-white mr-2"
                          disabled={IsInvalidFileFormat > 0}
                        >
                          {' '}
                          Submit{' '}
                        </button>
                        <Link
                          to="/attribute/productattribute"
                          className="btn btn-primary"
                        >
                          Cancel
                        </Link>
                      </div>
                    </div>
                    {/* {
                                            Inputs.input_type == "" || Inputs.input_type != 'text' &&
                                        } */}
                  </div>
                  <div
                    className={
                      Inputs.input_type === 'dropdown' ||
                      Inputs.input_type === 'radio' ||
                      Inputs.input_type === 'checkbox' ||
                      Inputs.input_type === 'range_slider' ||
                      Inputs.input_type === 'radio_image' ||
                      Inputs.input_type === 'text_swatch'
                        ? 'col-md-8 col-lg-6'
                        : 'col-md-8 col-lg-6 d-none'
                    }
                  >
                    <div className="col-md-12 text-right pr-0 mt-3 mt-md-0">
                      <button
                        className="btn btn-dark"
                        onClick={addOption}
                      >
                        Add Option
                      </button>
                    </div>
                    <p className="d-flex justify-content-between align-items-center flex-wrap">
                      Options{' '}
                      {Inputs.input_type === 'radio' && (
                        <label className="mt-2 float-right note">
                          (only .webp, .png, .jpg, .jpeg, .svg format is allowed)
                        </label>
                      )}
                    </p>{' '}
                    <Nestable
                      items={Inputs.options}
                      renderItem={renderItem}
                      collapsed={false}
                      onChange={changeOptionOrder}
                      maxDepth={1}
                    />
                    {/* {IsInvalidOptionImage && (
                      <div className="error">Option image file format not supported</div>
                    )} */}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div ref={bottomRef}> </div>
    </div>
  )
}
export default AddProductAttribute
